import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NotificationBannerService } from './notification-banner.service';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationBannerComponent {
  public isSelected = false;
  constructor(public notificationBannerService: NotificationBannerService) {}
}
